import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SearchSchools from '../district_components/SearchSchools'
import { updateUserSchool } from 'shared/api/mutations'
import { useUserResource } from 'shared/api/user'

const EditUserSchool = ({ userId }: { userId: number }) => {
  const { userData, reFetchUser } = useUserResource(userId)
  const onSubmit = async (selectedSchoolID: number) => {
    await updateUserSchool(userId, selectedSchoolID)
    reFetchUser()
  }
  if (!userData) return <Box>Loading...</Box>

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {userData.school ? (
          <>
            <span>Edit School:&nbsp;</span>
            <b>{userData.school.name}</b>
            <i>&nbsp;{userData.school.id}</i>
          </>
        ) : (
          <p>Add User to School</p>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <SearchSchools submitFn={onSubmit} clearAfterSubmit={true} />
      </AccordionDetails>
    </Accordion>
  )
}

export default EditUserSchool
